export const REPORT_LIST_COLUMNS = [
  { field: 'nomeRelatorio', headerName: 'Nome', align: 'left', sort: 'asc' },
  {
    field: 'observacoes',
    headerName: 'Observações',
    align: 'left',
    sort: 'asc'
  },
  {
    field: 'dataDaSolicitacao',
    headerName: 'Data da Solicitação',
    align: 'center',
    sort: 'asc'
  },
  {
    field: 'status',
    headerName: 'Situação',
    align: 'center',
    sort: 'asc'
  },
  { field: 'acoes', headerName: '', align: 'center' }
]
